// @ts-nocheck
import "./App.css";
import React from "react";
// eslint-disable-next-line
import DeckGL from "!@deck.gl/react";
// eslint-disable-next-line
import { HexagonLayer } from "!@deck.gl/aggregation-layers";
// eslint-disable-next-line
import { StaticMap } from "!react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";

const data = require("./data/powerpoints.json");
enum fuelTypes {
  Hydro,
  Oil,
  Gas,
  Solar,
  Coal,
  Wind,
}

const MAPBOX_ACCESS_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN ?? "";
const MAX_CAPACITY = 25000;

const INITIAL_VIEW_STATE = {
  longitude: -66.666298637062695,
  latitude: 18.335899336487358,
  zoom: 8.5,
  pitch: 77,
  bearing: -16,
};

const colorRange = [
  [25, 25, 255], // Hydro
  [150, 75, 0], // Oil
  [0, 191, 255], // Gas
  [128, 128, 0], // Solar
  [10, 10, 10], // Coal
  [0, 255, 0], // Wind
];

const layers = [
  new HexagonLayer({
    id: "hexagon-layer",
    colorRange,
    coverage: 1,
    data,
    elevationRange: [0, MAX_CAPACITY],
    elevationScale: 1,
    extruded: true,
    pickable: true,
    radius: 1000,
    upperPercentile: 100,
    getPosition: (d) => d.geometry.coordinates,
    getElevationWeight: (d) => d.properties.capacity_mw,
    getColorWeight: (d) => fuelTypes[d.properties.primary_fuel],
  }),
];

const getTooltip = ({ object }) => {
  return (
    object &&
    `${object.position.join(", ")}
        name: ${object.points[0].source.properties.name}
        owner: ${object.points[0].source.properties.owner}
        primary fuel: ${object.points[0].source.properties.primary_fuel}
        capacity: ${object.points[0].source.properties.capacity_mw} mW
        colorValue: ${object.colorValue}`
  );
};

const App = () => {
  return (
    <DeckGL
      initialViewState={INITIAL_VIEW_STATE}
      controller={true}
      layers={layers}
      getTooltip={getTooltip}
    >
      <StaticMap
        mapStyle="mapbox://styles/mapbox/light-v10"
        mapboxApiAccessToken={MAPBOX_ACCESS_TOKEN}
      />
    </DeckGL>
  );
};

export { App };
